export class EmailInfo {
    public from: string = '';
    public to: string = '';
    public cc: string = '';
    public subject: string = '';
    public format: string = '';
    public body: string = '';
}
